import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import { redirectToAgentDetails } from '@cp/src/utils/commonUtils';
import store from '@cp/src/store';
import EllipsisText from '@cp/src/components/EllipsisText';
import { AnomalyType, ITableRaisedFor } from '../../types';
import MapIcon from '@cp/src/assets/icons/MapIcon';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import dayjs from 'dayjs';
import { DateFormat } from '@cp/src/utils/DateHelper';

const RaisedFor = (props: ITableRaisedFor) => {
  const { info } = props;
  const { createdAt, raisedFor, anomalyDetectedOn } = info || {};
  const { name, id, agencyCode, allocations } = raisedFor || {};
  const mapViewDate = dayjs(createdAt).format(DateFormat.ISO_DATE_FORMAT);
  const handleMapRedirection = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    redirectToAgentDetails(
      id,
      agencyCode,
      mapViewDate,
      store?.getState()?.common?.featureFlags?.externalAgencyPerformanceDashboard
    );
  };
  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-1">
        <Tooltip placement={'top'} hiddenPadding={0} hideStrategy="referenceHidden">
          <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper max-w-full">
            <EllipsisText ellipsisWrapperClass={styles.ellipsisWrapperClass} text={name} />
          </TooltipTrigger>
          <TooltipContent className={'tooltipWrapper'}>{name}</TooltipContent>
        </Tooltip>
        {anomalyDetectedOn === AnomalyType.AGENT ? (
          <Tooltip placement={'top'} hiddenPadding={0} hideStrategy="referenceHidden">
            <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
              <div className="cursor-pointer" onClick={handleMapRedirection}>
                <MapIcon />
              </div>
            </TooltipTrigger>
            <TooltipContent className={'tooltipWrapper'}>Open Map View</TooltipContent>
          </Tooltip>
        ) : null}
      </div>
      {allocations ? (
        <Typography color="var(--grayscale-3)" className="truncate" variant="h4">
          {allocations} allocations
        </Typography>
      ) : null}
    </div>
  );
};

export default RaisedFor;
